const sleep = (millis) => {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, millis)
  })
}
let waitloopcount = 0
/**
 *
 * @param {import("node_modules/@vue/reactivity/dist/reactivity").Ref<boolean>} globalLoadingStatus
 * @returns {Promise<boolean>}
 */
const waitForLoadingFinished = async (globalLoadingStatus) => {
  // console.log('awaiting 500ms')
  await sleep(500)
  // wait at maximum 20 times (500ms*20 = 10s)
  waitloopcount++
  console.log('checking loading status', globalLoadingStatus.value)
  if (globalLoadingStatus.value && waitloopcount < 20) {
    return waitForLoadingFinished(globalLoadingStatus)
  }
  return true
}
/**
 *
 * @param {import("node_modules/@vue/reactivity/dist/reactivity").Ref<boolean>} globalLoadingStatus
 */
export const routerScrollBehavior = (globalLoadingStatus) => {
  return async (to, from, savedPosition) => {
    waitloopcount = 0
    await waitForLoadingFinished(globalLoadingStatus)
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
}
